/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popRankActivity.vue?vue&type=template&id=5074d1c6&scoped=true"
import script from "./popRankActivity.vue?vue&type=script&lang=js"
export * from "./popRankActivity.vue?vue&type=script&lang=js"
import style0 from "./popRankActivity.vue?vue&type=style&index=0&id=5074d1c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074d1c6",
  null
  
)

export default component.exports